// ../../node_modules/@wix/bi-logger-rich-editor/dist/esm/v2/index.js
function addPluginLink(params) {
  return { evid: 26, src: 116, endpoint: "rich-editor", params };
}
function tablePluginDeleteColumnRow(params) {
  return { evid: 21, src: 116, endpoint: "rich-editor", params };
}
function searchInsideThePlugin(params) {
  return { evid: 34, src: 116, endpoint: "rich-editor", params };
}
function keyboardShortcutAction(params) {
  return { evid: 47, src: 116, endpoint: "rich-editor", params };
}
function pluginsPopoverTabSwitch(params) {
  return { evid: 51, src: 116, endpoint: "rich-editor", params };
}
function changePluginSettings(params) {
  return { evid: 25, src: 116, endpoint: "rich-editor", params };
}
function addPlugin(params) {
  return { evid: 2, src: 116, endpoint: "rich-editor", params };
}
function pluginsPopoverClick(params) {
  return { evid: 50, src: 116, endpoint: "rich-editor", params };
}
function openEditorSuccess(params) {
  return { evid: 9, src: 116, endpoint: "rich-editor", params };
}
function uploadMediaTry(params) {
  return { evid: 13, src: 116, endpoint: "rich-editor", params };
}
function tablePluginAddColumnRow(params) {
  return { evid: 20, src: 116, endpoint: "rich-editor", params };
}
function changePlugin(params) {
  return { evid: 3, src: 116, endpoint: "rich-editor", params };
}
function inlineToolbarOpened(params) {
  return { evid: 46, src: 116, endpoint: "rich-editor", params };
}
function publishPost(params) {
  return { evid: 5, src: 116, endpoint: "rich-editor", params };
}
function contentAdded(params) {
  return { evid: 16, src: 116, endpoint: "rich-editor", params };
}
function deletePlugin(params) {
  return { evid: 4, src: 116, endpoint: "rich-editor", params };
}
function pluginModalOpened(params) {
  return { evid: 33, src: 116, endpoint: "rich-editor", params };
}
function viewerAction(params) {
  return { evid: 8, src: 116, endpoint: "rich-editor", params };
}
function tablePluginClickOnOptionMenu(params) {
  return { evid: 22, src: 116, endpoint: "rich-editor", params };
}
function viewerLoaded(params) {
  return { evid: 15, src: 116, endpoint: "rich-editor", params };
}
function audioPluginDetails(params) {
  return { evid: 55, src: 116, endpoint: "rich-editor", params };
}
function addPluginSuccess(params) {
  return { evid: 6, src: 116, endpoint: "rich-editor", params };
}
function uploadMediaFinished(params) {
  return { evid: 14, src: 116, endpoint: "rich-editor", params };
}
function addPluginStep(params) {
  return { evid: 11, src: 116, endpoint: "rich-editor", params };
}
function menuLoad(params) {
  return { evid: 17, src: 116, endpoint: "rich-editor", params };
}
function tablePluginClickActionFromOptionMenu(params) {
  return { evid: 23, src: 116, endpoint: "rich-editor", params };
}
function pluginTableColumnRowAction(params) {
  return { evid: 32, src: 116, endpoint: "rich-editor", params };
}
function searchForPlugin(params) {
  return { evid: 35, src: 116, endpoint: "rich-editor", params };
}
function settingsModalOpenedForPlugin(params) {
  return { evid: 36, src: 116, endpoint: "rich-editor", params };
}
function settingsModalClosedForPlugin(params) {
  return { evid: 37, src: 116, endpoint: "rich-editor", params };
}
export {
  addPlugin,
  addPluginLink,
  addPluginStep,
  addPluginSuccess,
  audioPluginDetails,
  changePlugin,
  changePluginSettings,
  contentAdded,
  deletePlugin,
  inlineToolbarOpened,
  keyboardShortcutAction,
  menuLoad,
  openEditorSuccess,
  pluginModalOpened,
  pluginTableColumnRowAction,
  pluginsPopoverClick,
  pluginsPopoverTabSwitch,
  publishPost,
  searchForPlugin,
  searchInsideThePlugin,
  settingsModalClosedForPlugin,
  settingsModalOpenedForPlugin,
  tablePluginAddColumnRow,
  tablePluginClickActionFromOptionMenu,
  tablePluginClickOnOptionMenu,
  tablePluginDeleteColumnRow,
  uploadMediaFinished,
  uploadMediaTry,
  viewerAction,
  viewerLoaded
};
//# sourceMappingURL=wix-bi-logger-rich-editor.js.map
